// 用户中心路由配置
import UserCenter from '@/pages/ucenter/Index.vue'
import AccountSecurity from '@/pages/ucenter/Security.vue'
import OrderList from '@/pages/ucenter/OrderList.vue'
import OrderHistory from '@/pages/ucenter/OrderHistory.vue'
import Favorites from '@/pages/ucenter/Favorites.vue'
import Invoices from '@/pages/ucenter/Invoices.vue'
import InvoiceAdd from '@/pages/ucenter/InvoiceAdd.vue'
import Addresses from '@/pages/ucenter/Addresses.vue'
import PreOrderAdd from '@/pages/ucenter/PreOrderAdd.vue'
import PreOrderList from '@/pages/ucenter/PreOrderList.vue'
import Approve from '@/pages/ucenter/Approve.vue'


// 用户中心路由数组
export const ucenterRoutes = [
  {
    path: '/ucenter/Index',
    name: 'UserCenter',
    component: UserCenter,
    meta: {
      title: '用户中心',
      requireAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/ucenter/Security',
    name: 'AccountSecurity',
    component: AccountSecurity,
    meta: {
      title: '账户安全',
      requireAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/ucenter/OrderList',
    name: 'OrderList',
    component: OrderList,
    meta: {
      title: '我的订单',
      requireAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/ucenter/OrderHistory',
    name: 'OrderHistory',
    component: OrderHistory,
    meta: {
      title: '历史订单',
      requireAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/ucenter/Favorites',
    name: 'Favorites',
    component: Favorites,
    meta: {
      title: '我的收藏',
      requireAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/ucenter/Invoices',
    name: 'Invoices',
    component: Invoices,
    meta: {
      title: '发票管理',
      requireAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/ucenter/Addresses',
    name: 'Addresses',
    component: Addresses,
    meta: {
      title: '地址管理',
      requireAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/ucenter/preorderadd',
    name: 'PreOrderAdd',
    component: PreOrderAdd,
    meta: {
      title: '添加预订',
      requireAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/ucenter/preorderlist',
    name: 'PreOrderList',
    component: PreOrderList,
    meta: {
      title: '预订单列表',
      requireAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/ucenter/approve',
    name: 'Approve',
    component: Approve,
    meta: {
      title: '认证分销伙伴',
      requireAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/ucenter/invoiceadd',
    name: 'InvoiceAdd',
    component: InvoiceAdd,
    meta: {
      title: '添加发票',
      requireAuth: true // 需要登录才能访问
    }
  },
]

export default ucenterRoutes



// WEBPACK FOOTER //
// ./src/router/ucenter.js